import { combineReducers } from 'redux'
import connection from './connection'
import info from './info'
import status from './status'
import transaction from './transaction'

export default combineReducers({
    connection,
    info,
    status,
    transaction,
})
